import React from "react";
import apStudents from "../../../resources/feedback/ap.png";
import apFeedback from "../../../resources/feedback/ap feedback";
import CarouselRow from "../../common/CarouselRow";
import ImageCard from "../../common/ImageCard";
import { useGetMediaQuery } from "../../hooks/useMediaQuery";
import { useTranslation } from "react-i18next";

const ApFeedback = () => {
    const { isMobile } = useGetMediaQuery();
    const { t } = useTranslation("home");

    const gallery = apFeedback.map((fb, index) => (
        <ImageCard src={fb} key={index} children={index} />
    ));

    return (
        <div className="text-center py-4">
            <div className="text-2xl text-emerald-400 py-4 font-bold">
                {t("apFeedback.title")}
            </div>

            <div className="flex justify-center text-lg lg:space-x-20 md:space-x-10">
                <p className="w-1/3 text-left">
                    {t("apFeedback.p1.line1")}
                    <br />
                    <br />
                    {t("apFeedback.p1.line2")}
                    <code className="font-bold text-emerald-600">
                        {" "}
                        {t("apFeedback.p1.highlight")}
                    </code>
                    {t("apFeedback.p1.line3")}
                </p>

                <ImageCard src={apStudents} />
            </div>

            <CarouselRow children={gallery} mobileGroup={1} desktopGroup={5} />
        </div>
    );
};

export default ApFeedback;
